import _ from 'underscore'
import React from 'react'
import moment from 'moment'

class CalendarTime extends React.Component {
  render() {
    if (_.isEmpty(this.props.date)) {
      return null
    }

    const date = this.props.date
    const formatted = moment(date).calendar()

    return (
      <span title={date}>{formatted}</span>
    )
  }
}

export default CalendarTime
